import { render, staticRenderFns } from "./EntityCollections.vue?vue&type=template&id=064e68a8"
import script from "./EntityCollections.vue?vue&type=script&lang=js"
export * from "./EntityCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports